import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import clsx from 'clsx';
import visuallyHiddenStyles from './VisuallyHidden.module.css.js';
import { Base } from '../../Internal/Base/Base.js';

const VisuallyHidden = ({ className, ...props }) => (jsxRuntimeExports.jsx(Base, { className: clsx(visuallyHiddenStyles.visuallyHidden, className), ...props, children: props.children }));
VisuallyHidden.displayName = 'VisuallyHidden';

export { VisuallyHidden };
//# sourceMappingURL=VisuallyHidden.js.map
